import { Component, computed, effect, input, output, signal, viewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ImageUtils } from '../../../../../common/utils/image-utils';
import { WageringGameRow } from './wagering-profile.model';

@Component({
  selector: 'app-wagering-profile-game-list',
  templateUrl: './wagering-profile-game-list.component.html',
  styleUrls: ['./wagering-profile-game-list.component.scss'],
  standalone: false,
})
export class WageringProfileGameListComponent {
  readonly title = input('');
  readonly listKey = input('');
  readonly rows = input<WageringGameRow[]>([]);
  readonly editMode = input(false);

  readonly add = output<void>();
  readonly remove = output<WageringGameRow>();

  private readonly paginator = viewChild(MatPaginator);

  readonly dataSource = new MatTableDataSource<WageringGameRow>([]);
  readonly filterValue = signal('');

  readonly pageSize = 10;
  readonly pageSizeOptions = [10, 25, 50];

  readonly displayedColumns = computed(() =>
    this.editMode() ? ['logo', 'name', 'provider', 'actions'] : ['logo', 'name', 'provider']
  );
  readonly totalCount = computed(() => this.rows().length);
  readonly showPaginator = computed(() => this.totalCount() > this.pageSize);

  constructor() {
    this.dataSource.filterPredicate = (row, filter) => {
      const gi = row.gameInstance;
      return [gi?.name, gi?.provider, gi?.studioName, gi?.id].join(' ').toLowerCase().includes(filter);
    };

    effect(() => {
      this.dataSource.data = this.rows();
      this.dataSource.filter = this.filterValue().trim().toLowerCase();
      const paginator = this.paginator();
      if (paginator) {
        this.dataSource.paginator = paginator;
      }
    });
  }

  applyFilter(value: string): void {
    this.filterValue.set(value ?? '');
    this.dataSource.filter = this.filterValue().trim().toLowerCase();
  }

  clearFilter(): void {
    this.applyFilter('');
  }

  logoSrc(row: WageringGameRow): string {
    const url = row.gameInstance?.logoUrl;
    return url ? ImageUtils.relocateImage(url) : '';
  }
}
